import { Component, OnInit } from '@angular/core';
import { DictionaryCurrencyService } from '../../../app/shared/services/dictionary-currency-service';
import { DictionaryCurrencyEntity } from '../../../app/shared';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';
import { AddCurrencyDialogComponent } from 'src/components/pages/dictionaries-currencies-tab/add-currency-dialog/add-currency-dialog.component';
import { DictionaryType } from '../../shared/dictionaries-layout';
import {
  CustomButtonDefinition,
  DataTableDataDefinition,
} from '../../../app/shared/fca-data-table';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorDialogComponent } from '../../shared/error-dialog/error-dialog.component';

@Component({
  standalone: false,
  selector: 'dictionary-currencies-tab',
  templateUrl: './currencies.component.html',
  styleUrls: ['./currencies.component.scss'],
})
export class DictionaryCurrenciesTab implements OnInit {
  data: DictionaryCurrencyEntity[] | null = null;
  pageSize = 10;

  dataDefinition: DataTableDataDefinition<DictionaryCurrencyEntity> = [
    {
      name: '',
      allowGroup: true,
      columns: [
        {
          fieldName: 'Code',
          caption: 'Currency',
          valueType: 'text',
          editable: false,
          deletable: true,
        },
      ],
    },
  ];

  constructor(
    private dataService: DictionaryCurrencyService,
    public dialog: MatDialog
  ) {}

  title = 'Dictionary';
  dictionaryType = DictionaryType.Currencies;
  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getAll().subscribe((receivedData) => {
      this.data = receivedData;
    });
  }

  customButtons: CustomButtonDefinition<DictionaryCurrencyEntity>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.confirmDelete.bind(this) as (x: any) => {},
    },
  ];

  isDialogOpen = false;

  addCurrency() {
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;

    const dialogRef = this.dialog.open(AddCurrencyDialogComponent, {
      width: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: { name: '' },
    });

    dialogRef.componentInstance.onAddCallback = (code: string) => {
      this.dataService.add({ Code: code, Id: undefined }).subscribe({
        next: () => {
          this.loadData();
          dialogRef.close();
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 409) {
            this.dialog.open(ErrorDialogComponent, {
              data: { message: 'This currency already exists in the system.' },
            });
          }
        },
      });
    };

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }

  confirmDelete(currency: DictionaryCurrencyEntity) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.dataService.delete(currency).subscribe({
          next: () => {
            this.loadData();
          },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400 || error.status === 409) {
            const message = (error.error?.Message || error.error?.message || 'This currency is currently used in the system.').replace(/\n/g, '<br>');
            this.dialog.open(ErrorDialogComponent, {
              width: '350px',
              data: {
                title: 'Attention',
                message: message
              },
            });
          }
        },
        });
      }
    });
  }
}

